export default __webpack_public_path__ + "static/media/designer-cult-gaia.6abd0221.png";